// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"mClk5"};